import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsMapViewVector extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public label: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public description: string;

  @Expose()
  public meta: any;

  @Expose()
  public properties: any;

  @Expose()
  public geometry: any;

  @Expose()
  public mapView: any;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
